module.exports = __webpack_public_path__ + "img/组 220.fead1140.png";